import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const customerTypesSlice = createSlice({
  name: "customerTypes",
  initialState,
  reducers,
});

